






import Vue from 'vue'
import { PLANNING_ASSISTANT_DELETE_EMPLOYEE_FOR_EXCHANGE } from "@/store/action-types";
import { PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID } from '@/store/getter-types'

export default Vue.extend({
  name: "EmployeeDeleteCellRenderer",

  methods: {
    onDeleteEmployeeButtonClick (): void {
      // @ts-ignore
      this.$store.dispatch(PLANNING_ASSISTANT_DELETE_EMPLOYEE_FOR_EXCHANGE, this.params.data)
    },
  },

  computed: {
    showButton (): boolean {
      if(this.$store.getters[PLANNING_ASSISTANT_GET_AUTOMATIC_PLANNING_ID]) {
        return false
      } else {
        // @ts-ignore
        return this.params.data.employeeId !== undefined
      }
    }
  }
})
